/* global femcare */

femcare.shared.accordionDefault = {
    /**
     * Initializes the default standalone accordion component.
     */
    init: function () {
        const accordions = document.querySelectorAll('.accordion-standalone');
        if (accordions.length) {
            femcare.general.accordion.init('.accordion--default');
        }
    }
};
